import { useEffect, useRef, useState } from 'react'
// import BatoPick from '../../img/BatoBatoPick2ndYear.webp'
// import BasicCalculator from '../../img/ActivityBasicCalculator.webp'
// import Project1 from '../../img/MiniProject1.webp'
// import Project1Practice1 from '../../img/MiniProject1Practice1.webp'
// import Project1Practice2 from '../../img/MiniProject1Practice2.webp'
// import MiniProject2 from '../../img/MiniProject2.webp'
// import MiniProject3 from '../../img/MiniProject3Capstone.webp'
// import POSSYSTEM from '../../img/WayWeWorePOSSYSTEM.webp'
// import WWWWebsite from '../../img/WayWeWore-Website.webp'
// import RockScissorPaper from '../../img/RockScissorPaper.webp'
// import Fubbles from '../../img/Fubbles.webp'
// import WeatherandGeolocationAPI from '../../img/WeatherAPI.webp'
// import NetflixCloneWebsite from '../../img/NetflixCloneWebsite.webp'
import close from '../../img/close.webp'

const ProjectContent = ({ data }) => {

    //Content
    // const Images = [
    //     { id: 1, ProjectName: 'Bato-Bato-Pick', ProjectImage: BatoPick, ProjectDescription: 'Bato-Bato-Pick is a popular childrens game in the Philippines where players take turns picking rock, scissors, and papers', ProjectStacks: 'Java Swing GUI', ProjectLink: 'https://drive.google.com/file/d/1cKrcQW9K6zo933vUq4QY0H83UFFb6-Fh/view?usp=sharing' },
    //     { id: 2, ProjectName: 'Basic Calculator', ProjectImage: BasicCalculator, ProjectDescription: 'Basic calculator that has a feature of Addition, Subtraction, Multiplication, and Division', ProjectStacks: 'C# Windows Form', ProjectLink: 'https://drive.google.com/file/d/1hSEkqv1J9MUUQRFUP9X-txv5ud_Gj5i_/view?usp=share_link' },
    //     { id: 3, ProjectName: 'Git Resource', ProjectImage: Project1, ProjectDescription: 'Mini Project 1 in KodeGo. Git resource website is platform where users can learn and get reference about GIT version control system.', ProjectStacks: 'HTML, CSS, Bootstap', ProjectLink: 'https://mychhh.github.io/MiniProject1.github.io/' },
    //     { id: 4, ProjectName: 'Blogs Owl', ProjectImage: Project1Practice1, ProjectDescription: 'Blogs website about Owls.', ProjectStacks: 'HTML, Bootstap', ProjectLink: 'https://mychhh.github.io/Week2Project2.github.io/' },
    //     { id: 5, ProjectName: 'Philhealth Redesign', ProjectImage: Project1Practice2, ProjectDescription: 'Recreate the Philhealth landing page', ProjectStacks: 'HTML, CSS, Bootstap.', ProjectLink: 'https://mychhh.github.io/Mychhh-philhealth-redesign.github.io/' },
    //     { id: 6, ProjectName: 'PTable', ProjectImage: MiniProject2, ProjectDescription: 'Best in mini project 2 in KodeGo. The PTable consolidates useful information about the chemical elements into a single location.', ProjectStacks: 'ReactJS, ChakraUi, Bootstrap, Public API.', ProjectLink: 'https://kodego-miniproject2.vercel.app/' },
    //     { id: 7, ProjectName: 'School Portal', ProjectImage: MiniProject3, ProjectDescription: 'Capstone Project in KodeGo. The School Portal Designed for public schools, to disseminate information regarding school activities and requirements. With online enrollment.', ProjectStacks: 'Tailwind CSS, Alpine JS, Laravel, Livewire.(TALL stack) and MySQL Database', ProjectLink: 'https://kodegohighschool.tech/' },
    //     { id: 8, ProjectName: 'WayWeWore POS System', ProjectImage: POSSYSTEM, ProjectDescription: 'This WayWeWore POS system is a type of software specifically designed for clothing stores. It includes features such as Sales, Purchase, Inventory, Orders, User List, and Archive on the Admin side. While on client side, user can browse products and place order hassle free. ', ProjectStacks: 'C# .Net Framework Windows Form and MsSQL Database', ProjectLink: 'https://drive.google.com/file/d/1Td73lrHlyqjJmN7I2HUR3qLIZAvWDXgX/view?usp=sharing' },
    //     { id: 9, ProjectName: 'WayWeWore Website', ProjectImage: WWWWebsite, ProjectDescription: 'The purpose of this website is to have this clothing business a website existence, and showcase their products', ProjectStacks: 'Vanilla HTML, CSS, JavaScript', ProjectLink: 'https://way-we-wore-website.vercel.app/?fbclid=IwAR1KVjDM93zfB_boDfXRpjvOjy8twqsZKRwIWyqqwhaaQ6YWkE61eJHHh1Y' },
    //     { id: 10, ProjectName: 'Rock Scissor Paper', ProjectImage: RockScissorPaper, ProjectDescription: 'Rock Scissor Paper simple game that can be played on the browser', ProjectStacks: 'Vanilla HTML, CSS, JavaScript', ProjectLink: 'https://mychhh.github.io/SimpleGames/RockScissorPaper/index.html' },
    //     { id: 11, ProjectName: 'F\'ubbles', ProjectImage: Fubbles, ProjectDescription: 'A single page website with all information about the F\'ubbles Dishwasing Liquid. I built it from scratch to bring in to play my animation skills in CSS', ProjectStacks: 'Vanilla HTML, CSS, JavaScript', ProjectLink: 'https://f-ubbles.vercel.app/' },
    //     { id: 12, ProjectName: 'Weather & Geolocation API ', ProjectImage: WeatherandGeolocationAPI, ProjectDescription: 'Simple website are utilizing the Weather API with 5 days a head prediction as well as Geolocation API to locate your location and reflect the weather on your screen', ProjectStacks: 'Vanilla HTML, CSS, JavaScript', ProjectLink: 'https://ap-is.vercel.app/' },
    //     { id: 13, ProjectName: 'Netflix Clone Website API ', ProjectImage: NetflixCloneWebsite, ProjectDescription: 'Netflix clone API using TMDB API with a trailer search functionality', ProjectStacks: 'ReactJS, REST API', ProjectLink: 'https://netflix-clone-website-ashy.vercel.app/' },
    // ];



    // this will get first the length of array of object

    const Images = [];

    // Adds the props on to the Images array
    for (let i = 0; i < data.ImagesData.length; i++) {
        Images.push(data.ImagesData[i]);
    }


    const length = Images.length;

    //this is the container  for stack images array of object 
    const StackImages = []

    // this will iterate through the images object
    for (let i = 0; i < length; i++) {
        let pops = Images.pop();
        StackImages.push(pops);
    }

    const [clickedProject, setClickedProject] = useState({
        clickedName: null,
        clickedImg: null,
        clickedDescription: null,
        clickedStacks: null,
        clickedLinks: null,
    });


    const [viewImg, setViewImg] = useState(false);

    const handleImg = () => {
        setViewImg(!viewImg);
    }

    const handleClickedImg = (name, img, desc, stack, link) => {

        setClickedProject.clickedName = name;
        setClickedProject.clickedImg = img;
        setClickedProject.clickedDescription = desc;
        setClickedProject.clickedStacks = stack;
        setClickedProject.clickedLinks = link;

    }

    // useref
    const imgRef = useRef();

    useEffect(() => {

        let handler = (e) => {

            if (!imgRef.current.contains(e.target)) {
                setViewImg(false);
            }

        };

        // mouse down listener happens when you pushdown your mouse
        document.addEventListener("mousedown", handler, true);

        return () => {
            document.removeEventListener("mousedown", handler, true);
        }

    }, [setViewImg])


    return (
        <>
            {viewImg &&

                <div className='flex justify-center items-center h-full w-full fixed top-0 left-0 bg-gray-500 z-20 bg-slate-300 dark:bg-gray-800 bg-opacity-50 dark:bg-opacity-40'>
                    <div ref={imgRef} className='flex flex-col md:flex-row w-3/4 h-auto md:h-3/4 border-solid m-0 p-0 rounded-md bg-gradient-to-r from-gray-700 to-gray-300 dark:from-[#272829] dark:to-[#191c1a]'>

                        <div className='flex items-center justify-center w-full md:w-4/6 p-2 rounded-l-md'>
                            <img data-aos="zoom-in" data-aos-duration="1000" src={setClickedProject.clickedImg} alt="clicked img" />
                        </div>

                        <div className='flex justify-center flex-col gap-y-4 w-full md:w-2/6 p-2 rounded-r-md relative dark:text-white'>

                            {/* button to close */}
                            <button onClick={handleImg} className="hidden md:flex">
                                <img src={close} alt="close" className='h-7 rounded-full dark:bg-white absolute top-3 right-3' />
                            </button>

                            {/* header */}
                            <div>
                                <p className='text:normal md:text-xl font-base border-b border-b-black dark:border-b-white inline'>{setClickedProject.clickedName}</p>
                            </div>

                            {/* description of the project */}
                            <div className='text-sm md:text-lg font-light'>
                                <p>{setClickedProject.clickedDescription}</p>
                            </div>

                            {/* stacks */}
                            <div>
                                <p className='text-sm md:text-lg font-light'>This is built with: <span className='text-sm md:text-lg font-normal'>{setClickedProject.clickedStacks}</span></p>
                            </div>

                            {/* button to livelinks */}
                            <div>
                                <a href={setClickedProject.clickedLinks} target='_blank'>
                                    <button className='bg-black dark:bg-white dark:text-black text-white text-sm md:text-lg font-light dark:font-normal px-5 py-1 hover:scale-110 duration-300'>
                                        Live link

                                    </button>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            }

            <div className="w-10/12 mx-auto py-5 dark:text-white mt-10">
                <div className="grid grid-cols-10 gap-10 justify-center relative">
                    {StackImages.map((image, key) => (
                        <div key={image.id} data-aos="zoom-in" data-aos-duration="1000" className="theproject col-span-10 md:col-span-5 w-full h-80 bg-gradient-to-r from-gray-300 to-gray-700 dark:from-[#272829] dark:to-[#191c1a] relative overflow-hidden drop-shadow-2xl">
                            <p key={key} className='absolute top-10 left-10 text-lg font-light text-white bg-black rounded px-3 z-10'>{image.ProjectName}</p>
                            <button
                                onClick={() => {
                                    handleClickedImg(image.ProjectName, image.ProjectImage, image.ProjectDescription, image.ProjectStacks, image.ProjectLink);
                                    handleImg();
                                }}
                            >
                                <img src={image.ProjectImage} alt="ProjectImage" className='object-cover h-full w-full hover:scale-150 duration-1000 absolute md:left-1/4 top-0 pr-0 md:pr-20 lg:pr-44 py-5 ' />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default ProjectContent;